interface CTABannerProps {
  title: string;
  subtitle?: string;
  buttonText?: string;
  buttonHref?: string;
  secondaryButtonText?: string;
  secondaryButtonHref?: string;
}

export default function CTABanner({
  title,
  subtitle,
  buttonText = 'Appeler maintenant',
  buttonHref = 'tel:+33980803684',
  secondaryButtonText,
  secondaryButtonHref,
}: CTABannerProps) {
  return (
    <div className="bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-background-50">{title}</h2>
            {subtitle && (
              <p className="mt-2 text-sm md:text-base text-primary-100">{subtitle}</p>
            )}
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <a
              href={buttonHref}
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm md:text-base px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-base w-4 h-4 flex items-center justify-center"></i>
              {buttonText}
            </a>
            {secondaryButtonText && secondaryButtonHref && (
              <a
                href={secondaryButtonHref}
                className="inline-flex items-center gap-2 border-2 border-background-50/40 hover:border-background-50 text-background-50 font-semibold text-sm md:text-base px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {secondaryButtonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}